/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { JSMOperationsHorizontalNav } from './ui/index.tsx';

export const LazyJSMOperationsHorizontalNav: LazyComponent<() => React.JSX.Element | null> =
	lazyForPaint<typeof JSMOperationsHorizontalNav>(
		() =>
			import(/* webpackChunkName: "jira-operations-horizontal-nav" */ './ui/index.tsx').then(
				({ JSMOperationsHorizontalNav }) => JSMOperationsHorizontalNav,
			),
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	);

export const AsyncJSMOperationsHorizontalNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-operations-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalOperationsNav"
			packageName="jiraHorizontalNavJsmOperations"
			fallback="flag"
			teamName="alexstrasza"
		>
			<LazyJSMOperationsHorizontalNav />
		</JSErrorBoundary>
	</Placeholder>
);
